import initialState from '../initialState.js';
import {
    GET_USAGE
} from '../../actions/types/usage';

export default (state = initialState.usage, action) => {
    switch (action.type) {
        case GET_USAGE: {
            return {
                ...state,
                data: action.usage
            };
        }

        default:
            return state;
    }
};